module.exports = __webpack_public_path__ + "static/media/logofcblue.e661e70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logofcblue.png
// module id = 1269
// module chunks = 2